export default function Section({ title, subtitle, children, className }) {
  return (
    <section className={`section ${className || ""}`}>
      <div className="section__inner">
        {/* <header className="section__header">
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </header> */}

        <div className="section__content">{children}</div>
      </div>
    </section>
  );
}
